<template>
  <v-card
    outlined
    class="card-height d-flex"
    :color="issueComite ? 'grey' : null"
  >
    <v-card-text style="position: relative" class="p-0">
      <v-row class="h100 d-flex align-center" dense>
        <v-col cols="10">
          <a-plain-text-div>
            <template v-if="personnePhysique">
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.civilite`)]"
                >{{ civilite | civilite }}
              </a-plain-text-component>
              <a-plain-text-component :rules="[serverRule(`${prefix}.nom`)]">
                {{ nom }}
              </a-plain-text-component>
              <a-plain-text-component :rules="[serverRule(`${prefix}.prenom`)]">
                {{ prenom }}
              </a-plain-text-component>
            </template>
            <template v-if="personneMorale">
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.formeJuridique`)]"
              >
                {{ formeJuridique }}
              </a-plain-text-component>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.denomination`)]"
              >
                {{ denomination }}
              </a-plain-text-component>
            </template>
          </a-plain-text-div>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <template v-if="hasModifie">

            <a-tooltip-icon-button
              icon="mdi-pen"
              tooltip="Modifier les informations du membre"
              @click="modifie"
              data-testid="modifier-informations-membre"
            />
          </template>
          <template v-if="hasSupprime">
               <a-tooltip-icon-button
              icon="mdi-delete"
              tooltip="Supprimer le membre"
              @click="supprime"
              data-testid="supprimer-membre"
            />
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import makePersonneCard from "./makePersonneCard";
function map(src, dest) {
  dest.issueComite = src.issueComite;
  dest.prefix = src.prefix;
  dest.civilite = src.civilite;
  dest.nom = src.nom;
  dest.prenom = src.prenom;
  dest.formeJuridique = src.formeJuridique;
  dest.denomination = src.denomination;
  dest.type = src.type;
}

export default {
  mixins: [makePersonneCard(map)],
};
</script>

<style scoped>
.card-height {
  min-height: 68px;
}
</style>
